import { useQuery } from '@tanstack/react-query';
import { dashboardApi } from '../services/api';
import { useAuth } from '../contexts/AuthContext';
import { SUB_BU_QUERY_OPTIONS } from '../constants/QueryConstants';

/**
 * Fetches Delivery Manager options (value=email, label=name) for the selected BUs/Sub-BUs
 * via /dashboard/delivery-managers. Cascades off Business Unit + Sub-BU.
 * Returns empty list and no loading when businessUnits is empty or undefined.
 */
export function useDeliveryManagersOptions(
  businessUnits: string[] | undefined,
  subBus: string[] | undefined
) {
  const { user } = useAuth();
  const enabled = !!(businessUnits && businessUnits.length > 0);

  const result = useQuery({
    queryKey: ['delivery-manager-options', user?.id, businessUnits, subBus],
    queryFn: async () => {
      if (!businessUnits || businessUnits.length === 0) return [];
      return dashboardApi.getDeliveryManagers(businessUnits, subBus ?? []);
    },
    enabled,
    ...SUB_BU_QUERY_OPTIONS,
  });

  return {
    data: result.data ?? [],
    isLoading: result.isLoading,
    error: result.error,
    refetch: result.refetch,
  };
}
